import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  // Pick the right token based on the path being called
  const url = cfg.url || "";
  if (url.startsWith("/customer/") || url.startsWith("customer/")) {
    const t = localStorage.getItem("rb_customer_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } else if (url.startsWith("/promoter/") || url.startsWith("promoter/")) {
    const t = localStorage.getItem("rb_promoter_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } else {
    const t = localStorage.getItem("rb_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

// Decode a JWT payload without verifying (we only need the `kind` claim to
// route the user to the correct dashboard — server still verifies signature
// on every request). Returns null for malformed / expired tokens.
const decodeJwt = (t) => {
  if (!t) return null;
  try {
    const payload = JSON.parse(atob(t.split(".")[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) return null; // expired
    return payload;
  } catch {
    return null;
  }
};

// A stale token from a previous session (e.g. admin logged out incorrectly,
// then a promoter tries to sign in on the same browser) can bleed into the
// wrong dashboard's route guard. Every login helper calls `clearAllTokens`
// first so only ONE role token ever exists at a time.
export const clearAllTokens = () => {
  localStorage.removeItem("rb_token");
  localStorage.removeItem("rb_promoter_token");
  localStorage.removeItem("rb_customer_token");
};

export const setToken = (t) => {
  // Admin login → wipe promoter/customer tokens so they can't sneak into
  // the promoter dashboard via stale localStorage.
  localStorage.removeItem("rb_promoter_token");
  localStorage.removeItem("rb_customer_token");
  if (t) localStorage.setItem("rb_token", t);
  else localStorage.removeItem("rb_token");
};

export const getToken = () => {
  // Only return the token when it decodes as `kind: admin`. Prevents a
  // stale promoter/customer token stashed under rb_token from unlocking
  // the admin dashboard.
  const t = localStorage.getItem("rb_token");
  const p = decodeJwt(t);
  if (!p) return null;
  if ((p.kind || "admin") !== "admin") return null;
  return t;
};

export const setPromoterToken = (t) => {
  // Promoter login → wipe admin/customer tokens.
  localStorage.removeItem("rb_token");
  localStorage.removeItem("rb_customer_token");
  if (t) localStorage.setItem("rb_promoter_token", t);
  else localStorage.removeItem("rb_promoter_token");
};

export const getPromoterToken = () => {
  const t = localStorage.getItem("rb_promoter_token");
  const p = decodeJwt(t);
  if (!p) return null;
  if (p.kind !== "promoter") return null;
  return t;
};

export const setCustomerToken = (t) => {
  if (t) localStorage.setItem("rb_customer_token", t);
  else localStorage.removeItem("rb_customer_token");
};

export const getCustomerToken = () => {
  const t = localStorage.getItem("rb_customer_token");
  const p = decodeJwt(t);
  if (!p) return null;
  if (p.kind !== "customer") return null;
  return t;
};

export const getCustomerEmail = () => {
  const t = getCustomerToken();
  const p = decodeJwt(t);
  return p?.email || null;
};
